import axios from "axios";

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api",
    timeout: 10000, 
});

axiosInstance.interceptors.request.use(
    (config) => {
        console.log("Request sent to:", config.url);
        return config;
    },
    (error) => {
        console.error("Request error:", error);
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        console.log("Response received:", response);
        return response;
    },
    (error) => {
        console.error("Response error:", error.response || error.message);
        return Promise.reject(error);
    }
);

export default axiosInstance;
